import React, { useEffect, useState } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { Button } from './ui/Button';
import { useTranslations } from '../hooks/useTranslations';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const {
    lang,
    setLang,
    t
  } = useTranslations();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t('nav.aboutUs'),
    href: '#about'
  }, {
    name: t('nav.funding'),
    href: '#funding'
  }, {
    name: t('nav.howItWorks'),
    href: '#how-it-works'
  }, {
    name: t('nav.requirements'),
    href: '#requirements'
  }, {
    name: t('nav.testimonials'),
    href: '#testimonials'
  }, {
    name: t('nav.faq'),
    href: '#faq'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 backdrop-blur-sm py-5'}`} data-id="element-295">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-296">
        <div className="flex justify-between items-center" data-id="element-297">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center cursor-pointer" onClick={() => window.scrollTo(0, 0)} data-id="element-298">
            <img src="https://cdn.magicpatterns.com/uploads/oxFWMvdwUBRjCt1riBg7DA/Asset_44x.png" alt="Brixen Funding" className="h-8 md:h-10 w-auto" data-id="element-299" />
          </div>

          {/* Desktop Nav */}
          <div className="hidden xl:flex items-center space-x-6" data-id="element-300">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-600 hover:text-[#00E676] transition-colors" data-id="element-301">
                {link.name}
              </a>)}
          </div>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center space-x-4" data-id="element-302">
            {/* Language Toggle */}
            <div className="flex items-center gap-1 text-sm font-medium text-gray-600" data-id="element-303">
              <button onClick={() => setLang('en')} className={`px-2 py-1 rounded transition-colors ${lang === 'en' ? 'text-[#00E676] font-bold' : 'hover:text-gray-900'}`} data-id="element-304">
                EN
              </button>
              <span className="text-gray-400" data-id="element-305">|</span>
              <button onClick={() => setLang('es')} className={`px-2 py-1 rounded transition-colors ${lang === 'es' ? 'text-[#00E676] font-bold' : 'hover:text-gray-900'}`} data-id="element-306">
                ES
              </button>
            </div>

            <Button variant="primary" size="sm" onClick={() => document.getElementById('contact')?.scrollIntoView()} data-id="element-307">
              {t('nav.applyNow')}
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-308">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-gray-900 focus:outline-none" data-id="element-309">
              {isOpen ? <X className="h-6 w-6" data-id="element-310" /> : <Menu className="h-6 w-6" data-id="element-311" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-312">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-313">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-gray-700 hover:text-[#00E676] hover:bg-gray-50 rounded-md" onClick={() => setIsOpen(false)} data-id="element-314">
                {link.name}
              </a>)}

            {/* Mobile Language Toggle */}
            <div className="flex items-center justify-center gap-2 py-3 text-sm font-medium" data-id="element-315">
              <button onClick={() => setLang('en')} className={`px-3 py-2 rounded transition-colors ${lang === 'en' ? 'bg-[#00E676] text-white' : 'bg-gray-100 text-gray-700'}`} data-id="element-316">
                English
              </button>
              <button onClick={() => setLang('es')} className={`px-3 py-2 rounded transition-colors ${lang === 'es' ? 'bg-[#00E676] text-white' : 'bg-gray-100 text-gray-700'}`} data-id="element-317">
                Español
              </button>
            </div>

            <div className="mt-4 px-3 space-y-3" data-id="element-318">
              <a href="https://form.jotform.com/260402880146048" target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="block w-full text-center font-semibold px-6 py-3 rounded-full text-white bg-[#00E676] hover:bg-[#00d169] active:scale-[0.98] transition-all duration-200 shadow-md" data-id="element-319">
                {t('hero.cta')}
              </a>
              <Button variant="primary" fullWidth className="!bg-transparent !text-[#00E676] border-2 border-[#00E676] hover:!bg-[#00E676] hover:!text-white" onClick={() => {
            setIsOpen(false);
            document.getElementById('contact')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-320">
                {t('nav.applyNow')}
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}